import { mapColorTokenToClass, mapTextColor, mapColorTokenToCssVariable, mapGradient } from '../../../mappers.util.js';
import { Direction } from '../../../../contexts/session/Locale.js';

var colorStyleMapper = {
  backgroundColor: function backgroundColor(value, context) {
    if (typeof value === 'string') {
      return {
        classNames: [mapColorTokenToClass(value, 'bg', context.intent)]
      };
    }
    return {
      style: {
        background: mapGradient(value, context.isLtr ? Direction.LTR : Direction.RTL, context.theme, context.intent)
      }
    };
  },
  textColor: function textColor(value, context) {
    return {
      classNames: [mapTextColor(value, 'text', context)]
    };
  },
  placeholderTextColor: function placeholderTextColor(value, _ref) {
    var intent = _ref.intent;
    return {
      style: {
        '--placeholder-text-color': "var(".concat(mapColorTokenToCssVariable(value, 'colors', intent), ")")
      },
      classNames: ['placeholder--text-color']
    };
  },
  fill: function fill(value, context) {
    return {
      classNames: [mapTextColor(value, 'fill', context)]
    };
  },
  borderColor: function borderColor(value, context) {
    return {
      classNames: [mapColorTokenToClass(value, 'border', context.intent)]
    };
  }
};

export { colorStyleMapper };
//# sourceMappingURL=color.js.map
